import styled from "styled-components"
import {Card} from "@irati/ui/src/Layout"

const Wrapper = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border-bottom: 1px solid ${({theme}) => theme.colors.greys.light};
`

export default Wrapper
